import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Drawer } from '@mui/material';
import { X, Coffee, BookOpen, MapPin, Sword, Sparkles, Info, HelpCircle } from 'lucide-react'; 
import { AdminContext } from '../context/AdminContext'; // NOVO IMPORT

function MobileMenuDrawer({ open, onClose }) {
    const navigate = useNavigate();
    const { isAdmin } = useContext(AdminContext); // OBTENDO ESTADO DO ADMIN

    const handleNavigate = (path) => {
        navigate(path);
        onClose(); 
    };

    // Filtra os itens: 'Sobre o Café' e 'RPG' só aparecem para Admin por enquanto
    const publicMenuItems = [
        { text: 'Cardápio', path: '/cardapio', icon: Coffee },
        { text: 'Catálogo de Jogos', path: '/biblioteca', icon: BookOpen },
        { text: 'Localização', path: '/local', icon: MapPin },
    ];

    const adminMenuItems = [
        { text: 'Cardápio', path: '/cardapio', icon: Coffee },
        { text: 'Catálogo de Jogos', path: '/biblioteca', icon: BookOpen },
        { text: 'RPG', path: '/sobre/rpg', icon: Sword },
        { text: 'Localização', path: '/local', icon: MapPin },
        { text: 'Dúvidas Frequentes', path: '/faq', icon: HelpCircle },
        { text: 'Sobre o Café', path: '/sobre', icon: Info },
    ];

    const menuItems = isAdmin ? adminMenuItems : publicMenuItems;

    return (
            <Drawer anchor="left" open={open} onClose={onClose} sx={{ '& .MuiDrawer-paper': { boxSizing: 'border-box', width: { xs: '85vw', sm: 340 }, backgroundColor: '#FFF5EE', borderRight: '1px solid rgba(151,18,83,0.1)', padding: '24px' } }}>
                <div className="flex justify-between items-center mb-6">
                    <span className="font-serif text-3xl text-[#971253] tracking-wide">Menu</span>
                    <button onClick={onClose} className="p-2.5 bg-[#971253]/5 text-[#971253] rounded-full hover:bg-[#971253] hover:text-[#FFF5EE] transition-colors"><X size={20} /></button>
                </div>

                <div className="w-full h-[1px] bg-gradient-to-r from-[#971253]/20 to-transparent mb-6" />

                <nav className="flex flex-col gap-3 flex-grow">
                    {menuItems.map((item) => (
                        <button key={item.text} onClick={() => handleNavigate(item.path)} className="group flex items-center gap-4 p-4 rounded-2xl hover:bg-[#528a89]/5 transition-all text-left w-full border border-transparent hover:border-[#528a89]/10">
                            <div className="p-2.5 rounded-full bg-[#528a89]/10 text-[#528a89] group-hover:bg-[#528a89] group-hover:text-[#FFF5EE] transition-colors duration-300">
                                <item.icon size={20} strokeWidth={1.5} />
                            </div>
                            <span className="font-serif text-xl text-[#971253] group-hover:text-[#528a89] transition-colors duration-300">
                                {item.text}
                            </span>
                        </button>
                    ))}
                </nav>

                <div className="mt-10 pt-8 border-t border-[#dbcdac]/30">
                    <p className="text-[#528a89] text-sm font-light italic flex items-center gap-2"><Sparkles size={14} className="text-[#dbcdac]" />Jogos, encontros e histórias.</p>
                    <div className="mt-6 inline-flex items-start gap-2 p-3 rounded-xl bg-[#971253]/5 border border-[#971253]/10 w-full">
                        <Info size={16} className="text-[#dbcdac] shrink-0 mt-0.5" />
                        <span className="text-xs font-light tracking-wide text-stone-600"><strong className="font-medium text-[#971253] block">Aviso importante:</strong> Não trabalhamos com aluguel de jogos.</span>
                    </div>
                </div>
            </Drawer>
        );
    }

export default MobileMenuDrawer;